var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-container',{staticClass:"overflow-hidden p-2",attrs:{"fluid":""}},[(_vm.loaded)?_c('apexchart',{staticClass:"mt-3",attrs:{"type":"line","height":"300","options":_vm.chartOptions,"series":_vm.series}}):_vm._e()],1)}
var staticRenderFns = []

export { render, staticRenderFns }